import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import './TrackRsvpNotifications.less';

class NotificationActionComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
    };
  }

  render() {
    const { notificationObject, triggerConfirmation } = this.props;
    return (
      <div id="rsvp-notifications">
        <div className="rsvp-notifications-container">
          <Link to="/wedding/manage/guests/rsvp-notifications" className="text-btn back-btn"><i className="zolaicon zolaicon-chevron-left" /> BACK TO REQUESTS</Link>
          <div className="body">
            <div className="rsvp-card" />
            <h1>{notificationObject.first_name} {notificationObject.family_name} Is Requesting Access to RSVP</h1>
            <p>This guest is not on your guest list, so they cannot currently RSVP on your wedding website.</p>
            <div className="cta-section">
              <div className="col-xs-12 col-sm-4">
                <button className="btn-secondary btn rsvp-no" onClick={() => triggerConfirmation(notificationObject)}>
                Decline RSVP Request
                </button>
                <p>This guest will <b>not</b> be added to your list, and we will <b>not</b> reach out to them.</p>
              </div>
              <div className="col-xs-12 col-sm-4">
                <div className="cta-script-container">
                  <span className="cta-script">or</span>
                </div>
              </div>
              <div className="col-xs-12 col-sm-4">
                <Link
                  to={`/wedding/manage/guests/add-guest/${notificationObject.uuid}`}
                  className="btn-primary btn rsvp-yes"
                >
                Accept RSVP Request
                </Link>
                <p>This guest will be added to your list, and we&apos;ll send them an email with all the instructions.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NotificationActionComponent.propTypes = {
  notificationObject: PropTypes.shape({}),
  triggerConfirmation: PropTypes.func,
};

const mapStateToProps = state => (
  {
    guestRequestNotifications: state.publicWebsite.guestRequestObject,
    notificationObject: state.publicWebsite.guestRequestByUuid,
  }
);

export default connect(
  mapStateToProps,
  null
)(NotificationActionComponent);



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/trackRsvpNotifications/NotificationActionComponent.jsx